module.exports = __webpack_public_path__ + "static/media/031.38529453.jpg";